import React, { useState, useEffect } from 'react';
import { useStaticQuery, Link } from 'gatsby';
import Helmet from 'react-helmet';
import returnSortedNavigation from './returnSortedNavigation';
import getNavIconFromSlug from './getNavIconFromSlug';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Header = function Header(props) {
  var _useState = useState(false),
      scrolled = _useState[0],
      setScrolled = _useState[1];

  var _useState2 = useState(false),
      toggleMobileNav = _useState2[0],
      setToggleMobileNav = _useState2[1];

  var _useState3 = useState([]),
      websiteNavData = _useState3[0],
      setWebsiteNavData = _useState3[1];

  var _useState4 = useState(true),
      websiteNavLoading = _useState4[0],
      setWebsiteNavLoading = _useState4[1];

  var accropressWebsiteNavigation = useStaticQuery("1215279412");
  useEffect(function () {
    returnSortedNavigation({
      websiteNavJSON: props.navResultData || accropressWebsiteNavigation,
      fromGQL: props.navResultData ? false : true,
      setWebsiteNavData: setWebsiteNavData,
      websiteNavData: websiteNavData,
      setWebsiteNavLoading: setWebsiteNavLoading,
      websiteNavLoading: websiteNavLoading
    });
  }, [websiteNavLoading]);
  useEffect(function () {
    var handleScroll = function handleScroll(event) {
      if (window && window.scrollY === 0) {
        setScrolled(false);
      } else if (window && window.scrollY > 0) {
        setScrolled(true);
      }
    };

    if (window) {
      window.addEventListener('scroll', handleScroll);
    }
  }, [setWebsiteNavData, websiteNavData, setWebsiteNavLoading, setWebsiteNavLoading]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Helmet, {
      children: [/*#__PURE__*/_jsx("link", {
        rel: "shortcut icon",
        href: "/favicon.ico"
      }), /*#__PURE__*/_jsx("title", {
        children: props.gatsbyConfigSiteMetaData.title
      })]
    }), /*#__PURE__*/_jsx("header", {
      className: 'header ' + (scrolled === true ? 'scrolled' : ''),
      id: "header",
      children: /*#__PURE__*/_jsxs("div", {
        className: "container",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "logo",
          children: [/*#__PURE__*/_jsx(Link, {
            to: "/",
            children: /*#__PURE__*/_jsx("img", {
              src: props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload.length > 0 && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0] && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0].children ? props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0].children.find(function (o) {
                return o.id === 'logo-image';
              }).value : props.gatsbyConfigPluginsAPOptions.siteSettings.theme.themeSettingsDefinition[0].children.find(function (o) {
                return o.id === 'logo-image';
              }).default,
              alt: props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload.length > 0 && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0] && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0].children ? props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0].children.find(function (o) {
                return o.id === 'school-name-title';
              }).value : props.gatsbyConfigPluginsAPOptions.siteSettings.theme.themeSettingsDefinition[0].children.find(function (o) {
                return o.id === 'school-name-title';
              }).default
            })
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("span", {
              className: "primary",
              children: props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload.length > 0 && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0] && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0].children ? props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0].children.find(function (o) {
                return o.id === 'school-name-title';
              }).value : props.gatsbyConfigPluginsAPOptions.siteSettings.theme.themeSettingsDefinition[0].children.find(function (o) {
                return o.id === 'school-name-title';
              }).default
            }), /*#__PURE__*/_jsx("span", {
              className: "secondary",
              children: props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload.length > 0 && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0] && props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0].children ? props.gatsbyConfigPluginsAPOptions.siteSettings.themeSettingsPayload[0].children.find(function (o) {
                return o.id === 'school-name-subtitle';
              }).value : props.gatsbyConfigPluginsAPOptions.siteSettings.theme.themeSettingsDefinition[0].children.find(function (o) {
                return o.id === 'school-name-subtitle';
              }).default
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "website-nav-wrap",
          children: !websiteNavLoading ? /*#__PURE__*/_jsxs("div", {
            className: "website-nav-inner-wrap",
            children: [/*#__PURE__*/_jsx("div", {
              className: "menuToggler",
              onClick: function onClick() {
                return setToggleMobileNav(!toggleMobileNav);
              },
              children: !toggleMobileNav ? /*#__PURE__*/_jsx("span", {
                className: "fas fa-bars"
              }) : /*#__PURE__*/_jsx("span", {
                className: "fas fa-times"
              })
            }), /*#__PURE__*/_jsxs("ul", {
              className: toggleMobileNav ? 'toggledMobile' : '',
              children: [/*#__PURE__*/_jsxs("li", {
                className: "headerLink",
                children: [/*#__PURE__*/_jsxs(Link, {
                  to: "/",
                  className: "parentLink",
                  children: [/*#__PURE__*/_jsx("span", {
                    className: "fas fa-home"
                  }), /*#__PURE__*/_jsx("span", {
                    children: "Home"
                  })]
                }), props.pluginOptions.showSitemapHeaderLink && /*#__PURE__*/_jsx("div", {
                  className: "dropdown",
                  children: /*#__PURE__*/_jsx("ul", {
                    className: "inner",
                    children: /*#__PURE__*/_jsx("li", {
                      children: /*#__PURE__*/_jsx(Link, {
                        to: "/sitemap",
                        className: "childLink",
                        children: "Contents A-Z"
                      })
                    })
                  })
                })]
              }), websiteNavData && websiteNavData.length > 0 ? websiteNavData.map(function (item, i) {
                return /*#__PURE__*/_jsxs("li", {
                  className: "headerLink",
                  children: [/*#__PURE__*/_jsxs(Link, {
                    to: item.parentSlug ? item.parentSlug + item.slug : item.slug,
                    className: "parentLink",
                    children: [/*#__PURE__*/_jsx("span", {
                      className: getNavIconFromSlug(item.slug)
                    }), /*#__PURE__*/_jsx("span", {
                      children: item.title
                    })]
                  }), item.children && item.children.length > 0 && /*#__PURE__*/_jsx("div", {
                    className: "dropdown",
                    children: /*#__PURE__*/_jsx("ul", {
                      className: "inner",
                      children: item.children.map(function (child, i) {
                        return /*#__PURE__*/_jsx("li", {
                          children: /*#__PURE__*/_jsx(Link, {
                            to: child.parentSlug ? child.parentSlug + child.slug : child.slug,
                            className: "childLink",
                            children: child.title
                          })
                        }, i);
                      })
                    })
                  })]
                }, i);
              }) : /*#__PURE__*/_jsx("li", {
                className: "loading-nav"
              })]
            })]
          }) : /*#__PURE__*/_jsx("div", {
            className: "website-nav-inner-wrap"
          })
        })]
      })
    })]
  });
};

export default Header;